import { render, staticRenderFns } from "./DataField.vue?vue&type=template&id=ed58f98e"
import script from "./DataField.vue?vue&type=script&lang=js"
export * from "./DataField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports